import React, { useCallback } from 'react';
import styles from './CreateChildProfile.module.css';
import { CreateChildProfileElement } from '../CreateChildProfileElement';

export const DesktopView = (): JSX.Element => {
  // Redux Hooks

  const createChildProfileElement = CreateChildProfileElement();
  return (
    <React.Fragment>
      <div className={styles.titleDiv} id="title">
        <b className={styles.createChildProfile1}>Create Child Profile</b>
      </div>
      <div
        className={styles.createChildProfileMainGrouDiv}
        id="create-child-profile-main-group"
      >
        <div className={styles.inputItemsDiv}>
          <div className={styles.avatarIcon}>
            {createChildProfileElement.avatarSelector}
          </div>
          <div
            className={styles.createChildProfileMainInpuDiv}
            id="create-child-profile-main-input-group"
          >
            <div className={styles.createChildProfileMainInpuDiv1}>
              {createChildProfileElement.firstNameInput}
              {createChildProfileElement.lastNameInput}
            </div>
            {createChildProfileElement.schoolInput}
            {createChildProfileElement.genderSelect}
            <div className={styles.dateOfBirth}>Date of Birth</div>
            <div
              className={styles.createChildProfileMainDobDiv}
              id="create-child-profile-main-dob-group"
            >
              {createChildProfileElement.dobDaySelect}
              {createChildProfileElement.dobMonthSelect}
              {createChildProfileElement.dobYearSelect}
            </div>
          </div>
        </div>
      </div>
      <div
        className={styles.createChildProfileFooterDiv}
        id="create-child-profile-footer"
      >
        <div
          className={styles.createChildProfileNextButtButton}
          id="create-child-profile-next-button"
        >
          {createChildProfileElement.nextButton}
        </div>
      </div>
    </React.Fragment>
  );
};
